// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__7K2jF","meals-appear":"AvailableMeals_meals-appear__Vbefk","mealsloading":"AvailableMeals_mealsloading__lsfwo"};